module.exports = __webpack_public_path__ + "img/nashville.8050d00d.jpeg";